<template>
    <div class="customer-personal-data-component">
        <mobile-go-back-button></mobile-go-back-button>
        <h2 class="mb-10">{{ trans.get('customer.personal-data') }}</h2>
        <form @submit.prevent="handleSubmit" v-if="userData">
            <div class="personal-data-grid mb-10">
                <floating-input
                    name="name"
                    :placeholder="trans.get('customer.full-name')"
                    type="text"
                    :initial-value="userData.name"
                    @input="userData.name = $event"
                >
                </floating-input>
                <floating-input
                    name="email"
                    :placeholder="trans.get('customer.email')"
                    type="email"
                    :initial-value="userData.email"
                    @input="userData.email = $event"
                >
                </floating-input>
                <div class="flex">
                    <v-select
                        class="min-width-8"
                        :options="phonePrefixes"
                        :placeholder="trans.get('wizard.phone_prefix')"
                        @input="(data) => {userData.phone_prefix = data.code}"
                        :value="userData.phone_prefix"
                    >
                    <template #option="{ label, icon }">
                        <div class="flex items-center"><span class="mr-2">{{ label }}</span> <img loading="lazy" class="h-4" :src="`/img/flags/${icon}.png`"></div>
                    </template>
                    </v-select>
                    <floating-input
                        class="ml-4 w-full"
                        name="phone"
                        :placeholder="trans.get('customer.phone')"
                        type="text"
                        :initial-value="userData.phone"
                        @input="userData.phone = $event"
                    >
                    </floating-input>
                </div>
            </div>
            <button class="btn btn-primary has-spinner block mx-auto lg:mx-0">
                <span v-show="! loading">{{ trans.get('customer.save-changes') }}</span>
                <span v-show="loading" class="spinner"></span>
            </button>
        </form>
    </div>
</template>

<script>
import axios from 'axios';
import MobileGoBackButton from './MobileGoBackButton';
import { phonePrefixes} from "../../phonePrefixes";

export default {
    components: {
        MobileGoBackButton,
    },

    data() {
        return {
            userData: { ...this.$store.state.customer.storedData.personalData },
            loading: false,
            phonePrefixes: phonePrefixes
        }
    },

    methods: {
        handleSubmit() {
            this.loading = true;
            axios.put('/customer-data/personal-data', this.userData)
                .then(this.handleSuccess)
                .catch(this.handleError)
                .finally(() => this.loading = false);
        },
        handleSuccess() {
            this.$toast.open(this.trans.get('customer.data-updated-success'));
            this.$store.commit('customerSetStoredData', ['personalData', { ...this.userData }]);
        },
        handleError() {
            this.$toast.error(this.trans.get('customer.something-went-wrong'));
        }
    },
}
</script>

<style lang="scss">
.customer-personal-data-component {
    .personal-data-grid {
        display: grid;
        grid-template-columns: 1fr;
        gap: 1.25rem;

        @media (min-width: 640px) {
            grid-template-columns: repeat(auto-fit, minmax(15rem, 1fr))
        }
        @media (min-width: 1024px) {
            grid-template-columns: repeat(auto-fit, minmax(15rem, 18rem))
        }
    }
    .field-wrapper {
        @media (min-width: 1366px) {
            min-width: 18rem;
        }

        .field-placeholder span {
            background: white !important;
        }
    }
}
</style>

